import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

// routing
import "./plugins/historyState";
import router from "./router";

import store from "./store";
import "./plugins/firebase";
import "@fortawesome/fontawesome-free/css/all.css";
import "./plugins/common";
import "./plugins/moment";

Vue.config.productionTip = false;

// animate.css
import AnimateCss from "animate.css";
Vue.use(AnimateCss);

// firestore
import { firestorePlugin } from "vuefire";
Vue.use(firestorePlugin);

// axios
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
